import { combineReducers } from 'redux'
import auth from './auth'
import healthCareService from './healthCareService'
import main from './main'
import help from './help'

const rootReducer = combineReducers({
    auth,
    healthCareService,
    main,
    help,
})

export default rootReducer
